import { compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    LocalizedSubsectionTitle,
    SpacingMediumAll,
    SpacingMediumLeftRight,
    withAsyncContainer,
} from '@mews-commander/ui';

import { Divider, Stack, Title } from '@optimus-web/core';
import { withScopeContext, AsyncMetaState } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import {
    hasReservationOverviewInitializingFailed,
    isReservationOverviewInitializing,
} from '../../../../selectors/summary';
import { Products } from '../ItemsOverview/Products';
import { AdditionalItems } from '../ItemsOverview/AdditionalItems';
import { ServiceName } from '../../../../../../components/commander-ui';
import { GuestCount } from './GuestCount';
import { Rates } from './Rates';
import { ResourceCategories } from './ResourceCategories';
import { ReservationStates } from './StateStatuses';
import { TimeUnitCount } from './TimeUnitCount';

const ReservationsOverviewContent: React.FC<{ serviceId: string }> = ({ serviceId }) => (
    <Stack spacing="200" vertical>
        <SpacingMediumAll>
            <Stack>
                <Title level={3}>
                    <ServiceName id={serviceId} />
                </Title>
                {UnicodeEntity.NoBreakSpace}
                <LocalizedSubsectionTitle textKey={TextKey.ReservationPlural} />
            </Stack>
        </SpacingMediumAll>
        <SpacingMediumLeftRight>
            <TimeUnitCount serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumLeftRight>
            <GuestCount serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumLeftRight>
            <ResourceCategories serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumLeftRight>
            <ReservationStates serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumLeftRight>
            <Rates serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumAll>
            <LocalizedSubsectionTitle textKey={TextKey.Items} />
        </SpacingMediumAll>
        <SpacingMediumLeftRight>
            <Products serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <SpacingMediumLeftRight>
            <AdditionalItems serviceId={serviceId} />
        </SpacingMediumLeftRight>
    </Stack>
);

interface OwnProps {
    scope: string;
    serviceId: string;
}

export default compose(
    withScopeContext,
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    connect<AsyncMetaState, null, OwnProps, ApplicationState>(
        createStructuredSelector({
            isFetching: isReservationOverviewInitializing,
            hasFailed: hasReservationOverviewInitializingFailed,
        })
    ),
    withAsyncContainer
    // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
)(ReservationsOverviewContent);
